import React from 'react'

// One measure for the whole marketing page. 1200px is wide enough for a
// twelve-column bento and narrow enough that a line of body text at the edge of
// a two-column layout stays readable.
const Container = ({ children, style = {} }) => (
  <div style={{
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 24px',
    width: '100%',
    boxSizing: 'border-box',
    ...style
  }}>
    {children}
  </div>
)

export default Container
